import {
  Accordion,
  useTheme,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
  useMediaQuery,
  Divider,
  Stack,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import { gridSpacing } from "../../../../../store/constants";
import TextField from "../../../../../utils/ui-components/FormsUI/TextField";
import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import MainCard from "../../../../../utils/ui-components/MainCard";
import CheckboxWrapper from "../../../../../utils/ui-components/FormsUI/Checkbox";
import RadioGroupWrapper from "../../../../../utils/ui-components/FormsUI/RadioGroup";
import { UserAddValues } from ".";
import Select from "../../../../../utils/ui-components/FormsUI/Select";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const operatorLabels: Record<number, string> = {
  1: "Robi",
  2: "Teletalk",
  3: "Banglalink",
  4: "Grameenphone",
};

function OperatorConfiguration({
  values,
  handleBack,
  setFieldValue,
  dirty,
  isSubmitting,
  isValid,
}: {
  values: UserAddValues;
  handleBack: () => void;
  setFieldValue: (x: string, y: any) => void;
  dirty: boolean;
  isSubmitting: boolean;
  isValid: boolean;
}) {
  const theme: any = useTheme();

  const matchDownMD = useMediaQuery(theme.breakpoints.down("lg"));
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));
  const [isLoading, setIsLoading] = useState(false);
  const [defaultOperator, setDefaultOperator] = useState<
    {
      value: number | string;
      label: string;
    }[]
  >(
    Object.entries(values.smsOperatorConfguraion)
      .filter(([_, value]) => typeof value === "object" && value !== null && "isUse" in value && (value as any).isUse === true)
      .map(([_, value]) => {
        const operator = value as { systemOperatorId: number };
        return {
          value: operator.systemOperatorId,
          label: operatorLabels[operator.systemOperatorId],
        };
      }),
  );
  const [passwordShowOperator, setPasswordShowOperator]: any = React.useState({
    1: { showPassword: false, showConfirmPassword: false },
    2: { showPassword: false, showConfirmPassword: false },
    3: { showPassword: false, showConfirmPassword: false },
    4: { showPassword: false, showConfirmPassword: false },
  });

  const handleClickShowPasswordOperator = (id: number) => {
    setPasswordShowOperator((prevState: any) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        showPassword: !prevState[id].showPassword,
      },
    }));
  };

  // const handleClickShowConfirmPasswordOperator = (id: number) => {
  //   setPasswordShowOperator((prevState: any) => ({
  //     ...prevState,
  //     [id]: {
  //       ...prevState[id],
  //       showConfirmPassword: !prevState[id].showConfirmPassword,
  //     },
  //   }));
  // };

  return (
    <MainCard sx={{ mt: 2 }}>
      <Grid container spacing={1} justifyContent={"center"}>
        <Grid item xs={12}>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#ffff" }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{
                backgroundColor: theme.palette.primary.main,
              }}
            >
              <Typography fontWeight={"bold"} variant="h4" color={"#ffff"}>
                SMS Operators Configuration
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={gridSpacing} justifyContent={"center"}>
                <Grid item xs={12}>
                  <CheckboxWrapper
                    customHandleChange={(e: any) => {
                      if (e.target.checked) {
                        setFieldValue("smsOperatorConfguraion", {
                          all: true,
                          defaultOperator: "",
                          robi: {
                            ...values.smsOperatorConfguraion.robi,
                            isUse: true,
                          },
                          tl: {
                            ...values.smsOperatorConfguraion.tl,
                            isUse: true,
                          },
                          bl: {
                            ...values.smsOperatorConfguraion.bl,
                            isUse: true,
                          },
                          gp: {
                            ...values.smsOperatorConfguraion.gp,
                            isUse: true,
                          },
                        });
                        setDefaultOperator([
                          { value: 1, label: operatorLabels[1] },
                          { value: 2, label: operatorLabels[2] },
                          { value: 3, label: operatorLabels[3] },
                          { value: 4, label: operatorLabels[4] },
                        ]);
                      } else {
                        setFieldValue("smsOperatorConfguraion", {
                          all: false,
                          defaultOperator: "",
                          robi: {
                            ...values.smsOperatorConfguraion.robi,
                            isUse: false,
                          },
                          tl: {
                            ...values.smsOperatorConfguraion.tl,
                            isUse: false,
                          },
                          bl: {
                            ...values.smsOperatorConfguraion.bl,
                            isUse: false,
                          },
                          gp: {
                            ...values.smsOperatorConfguraion.gp,
                            isUse: false,
                          },
                        });
                        setDefaultOperator([]);
                      }
                    }}
                    legend={"All Operators"}
                    name={"smsOperatorConfguraion.all"}
                    sx={{ pr: 0 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <RadioGroupWrapper
                    required
                    name="smsOperatorConfguraion.defaultOperator"
                    label="SMS Default Operator"
                    radioGroup={defaultOperator}
                    disabled={false}
                  />
                </Grid>

                <Grid item lg={12} container columnSpacing={1}>
                  <Grid item lg={2} md={2} sm={3} xs={3}>
                    <CheckboxWrapper
                      customHandleChange={(e: any) => {
                        if (
                          e?.target.checked &&
                          values.smsOperatorConfguraion.tl.isUse &&
                          values.smsOperatorConfguraion.bl.isUse &&
                          values.smsOperatorConfguraion.gp.isUse
                        ) {
                          setFieldValue("smsOperatorConfguraion", {
                            ...values.smsOperatorConfguraion,
                            all: true,
                            robi: {
                              ...values.smsOperatorConfguraion.robi,
                              isUse: e?.target.checked,
                            },
                          });
                          setDefaultOperator([...defaultOperator, { value: 1, label: operatorLabels[1] }]);
                        } else {
                          setFieldValue("smsOperatorConfguraion", {
                            ...values.smsOperatorConfguraion,
                            defaultOperator:
                              Number(values.smsOperatorConfguraion.defaultOperator) === 1
                                ? ""
                                : Number(values.smsOperatorConfguraion.defaultOperator),
                            all: false,
                            robi: {
                              ...values.smsOperatorConfguraion.robi,
                              isUse: e?.target.checked,
                            },
                          });
                          setDefaultOperator(defaultOperator.filter((item) => item.value !== 1));
                        }

                        if (e?.target.checked) {
                          setDefaultOperator(
                            [...defaultOperator, { value: 1, label: operatorLabels[1] }].sort((a, b) => Number(a.value) - Number(b.value)),
                          );
                        } else {
                          setDefaultOperator(defaultOperator.filter((item) => item.value !== 1).sort((a, b) => Number(a.value) - Number(b.value)));
                        }
                      }}
                      legend={"Robi"}
                      name={"smsOperatorConfguraion.robi.isUse"}
                      sx={{ pr: 0 }}
                    />
                  </Grid>
                  <Grid item lg={10} container spacing={1}>
                    <Grid item lg={2} md={5} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.robi.isUse}
                        type={"number"}
                        name="smsOperatorConfguraion.robi.tps"
                        label="TPS"
                      />
                    </Grid>
                    <Grid item lg={3.5} md={5} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.robi.isUse}
                        type={"text"}
                        name="smsOperatorConfguraion.robi.userName"
                        label="Username"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PersonIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item lg={3.5} md={5} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.robi.isUse}
                        type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        name="smsOperatorConfguraion.robi.password"
                        label="Password"
                        placeholder="Password"
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} container columnSpacing={1}>
                  <Grid item lg={2} md={2} sm={3} xs={3}>
                    <CheckboxWrapper
                      customHandleChange={(e: any) => {
                        if (
                          e?.target.checked &&
                          values.smsOperatorConfguraion.robi.isUse &&
                          values.smsOperatorConfguraion.bl.isUse &&
                          values.smsOperatorConfguraion.gp.isUse
                        ) {
                          setFieldValue("smsOperatorConfguraion", {
                            ...values.smsOperatorConfguraion,
                            all: true,
                            tl: {
                              ...values.smsOperatorConfguraion.tl,
                              isUse: e?.target.checked,
                            },
                          });
                        } else {
                          setFieldValue("smsOperatorConfguraion", {
                            ...values.smsOperatorConfguraion,
                            defaultOperator:
                              Number(values.smsOperatorConfguraion.defaultOperator) === 2
                                ? ""
                                : Number(values.smsOperatorConfguraion.defaultOperator),
                            all: false,
                            tl: {
                              ...values.smsOperatorConfguraion.tl,
                              isUse: e?.target.checked,
                            },
                          });
                        }
                        if (e?.target.checked) {
                          setDefaultOperator(
                            [...defaultOperator, { value: 2, label: operatorLabels[2] }].sort((a, b) => Number(a.value) - Number(b.value)),
                          );
                        } else {
                          setDefaultOperator(defaultOperator.filter((item) => item.value !== 2).sort((a, b) => Number(a.value) - Number(b.value)));
                        }
                      }}
                      legend={"Teletalk"}
                      name={"smsOperatorConfguraion.tl.isUse"}
                      sx={{ pr: 0 }}
                    />
                  </Grid>
                  <Grid item lg={10} container spacing={1}>
                    <Grid item lg={2} md={5} sm={8} xs={9}>
                      <TextField required={values.smsOperatorConfguraion.tl.isUse} type={"number"} name="smsOperatorConfguraion.tl.tps" label="TPS" />
                    </Grid>
                    <Grid item lg={3.5} md={5} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.tl.isUse}
                        type={"text"}
                        name="smsOperatorConfguraion.tl.userName"
                        label="Username"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PersonIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item lg={3.5} md={5} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.tl.isUse}
                        type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        name="smsOperatorConfguraion.tl.password"
                        label="Password"
                        placeholder="Password"
                      />
                    </Grid>
                    <Grid item lg={2} md={10} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.tl.isUse}
                        type={"text"}
                        name="smsOperatorConfguraion.tl.acode"
                        label="Acode"
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} container columnSpacing={1}>
                  <Grid item lg={2} md={2} sm={3} xs={3}>
                    <CheckboxWrapper
                      customHandleChange={(e: any) => {
                        if (
                          e?.target.checked &&
                          values.smsOperatorConfguraion.tl.isUse &&
                          values.smsOperatorConfguraion.robi.isUse &&
                          values.smsOperatorConfguraion.gp.isUse
                        ) {
                          setFieldValue("smsOperatorConfguraion", {
                            ...values.smsOperatorConfguraion,
                            all: true,
                            bl: {
                              ...values.smsOperatorConfguraion.bl,
                              isUse: e?.target.checked,
                            },
                          });
                        } else {
                          setFieldValue("smsOperatorConfguraion", {
                            ...values.smsOperatorConfguraion,
                            defaultOperator:
                              Number(values.smsOperatorConfguraion.defaultOperator) === 3
                                ? ""
                                : Number(values.smsOperatorConfguraion.defaultOperator),
                            all: false,
                            bl: {
                              ...values.smsOperatorConfguraion.bl,
                              isUse: e?.target.checked,
                            },
                          });
                        }
                        if (e?.target.checked) {
                          setDefaultOperator(
                            [...defaultOperator, { value: 3, label: operatorLabels[3] }].sort((a, b) => Number(a.value) - Number(b.value)),
                          );
                        } else {
                          setDefaultOperator(defaultOperator.filter((item) => item.value !== 3).sort((a, b) => Number(a.value) - Number(b.value)));
                        }
                      }}
                      legend={"Banglalink"}
                      name={"smsOperatorConfguraion.bl.isUse"}
                      sx={{ pr: 0 }}
                    />
                  </Grid>
                  <Grid item lg={10} container spacing={1}>
                    <Grid item lg={2} md={5} sm={8} xs={9}>
                      <TextField required={values.smsOperatorConfguraion.bl.isUse} type={"number"} name="smsOperatorConfguraion.bl.tps" label="TPS" />
                    </Grid>
                    <Grid item lg={3.5} md={5} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.bl.isUse}
                        type={"text"}
                        name="smsOperatorConfguraion.bl.userName"
                        label="Username"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PersonIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item lg={3.5} md={5} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.bl.isUse}
                        type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        name="smsOperatorConfguraion.bl.password"
                        label="Password"
                        placeholder="Password"
                      />
                    </Grid>
                    <Grid item lg={3} md={10} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.bl.isUse}
                        type="tel"
                        name="smsOperatorConfguraion.bl.billmsisdn"
                        label="Bill"
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} container columnSpacing={1}>
                  <Grid item lg={2} md={2} sm={3} xs={3}>
                    <CheckboxWrapper
                      customHandleChange={(e: any) => {
                        if (
                          e?.target.checked &&
                          values.smsOperatorConfguraion.tl.isUse &&
                          values.smsOperatorConfguraion.bl.isUse &&
                          values.smsOperatorConfguraion.robi.isUse
                        ) {
                          setFieldValue("smsOperatorConfguraion", {
                            ...values.smsOperatorConfguraion,
                            all: true,
                            gp: {
                              ...values.smsOperatorConfguraion.gp,
                              isUse: e?.target.checked,
                            },
                          });
                        } else {
                          setFieldValue("smsOperatorConfguraion", {
                            ...values.smsOperatorConfguraion,
                            defaultOperator:
                              Number(values.smsOperatorConfguraion.defaultOperator) === 4
                                ? ""
                                : Number(values.smsOperatorConfguraion.defaultOperator),
                            all: false,
                            gp: {
                              ...values.smsOperatorConfguraion.gp,
                              isUse: e?.target.checked,
                            },
                          });
                        }
                        if (e?.target.checked) {
                          setDefaultOperator(
                            [...defaultOperator, { value: 4, label: operatorLabels[4] }].sort((a, b) => Number(a.value) - Number(b.value)),
                          );
                        } else {
                          setDefaultOperator(defaultOperator.filter((item) => item.value !== 4).sort((a, b) => Number(a.value) - Number(b.value)));
                        }
                      }}
                      legend={"Grameenphone"}
                      name={"smsOperatorConfguraion.gp.isUse"}
                      sx={{ pr: 0 }}
                    />
                  </Grid>
                  <Grid item lg={10} container spacing={1}>
                    <Grid item lg={2} md={5} sm={8} xs={9}>
                      <TextField required={values.smsOperatorConfguraion.gp.isUse} type={"number"} name="smsOperatorConfguraion.gp.tps" label="TPS" />
                    </Grid>
                    <Grid item lg={3.5} md={5} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.gp.isUse}
                        type={"text"}
                        name="smsOperatorConfguraion.gp.userName"
                        label="Username"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PersonIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item lg={3.5} md={5} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.gp.isUse}
                        type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        name="smsOperatorConfguraion.gp.password"
                        label="Password"
                        placeholder="Password"
                      />
                    </Grid>
                    <Grid item lg={3} md={10} sm={8} xs={9}>
                      <TextField
                        required={values.smsOperatorConfguraion.gp.isUse}
                        type="tel"
                        name="smsOperatorConfguraion.gp.billmsisdn"
                        label="Bill"
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  {!values.smsOperatorConfguraion.bl.isUse &&
                    !values.smsOperatorConfguraion.gp.isUse &&
                    !values.smsOperatorConfguraion.robi.isUse &&
                    !values.smsOperatorConfguraion.tl.isUse && (
                      <Typography variant="caption" color={"error"}>
                        At least one sms reward operator required
                      </Typography>
                    )}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        {values.enableRewardCampaignCreation && (
          <Grid item xs={12} sx={{ mt: 0.1 }}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#ffff" }} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{
                  backgroundColor: theme.palette.primary.main,
                }}
              >
                <Typography fontWeight={"bold"} variant="h4" color={"#ffff"}>
                  Data Reward Operators Configuration
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={gridSpacing} justifyContent={"center"}>
                  <Grid item xs={12}>
                    <CheckboxWrapper
                      customHandleChange={(e: any) => {
                        if (e.target.checked) {
                          setFieldValue("rewardOperatorConfguraion", {
                            all: true,
                            robi: {
                              ...values.rewardOperatorConfguraion.robi,
                              isUse: true,
                            },
                            tl: {
                              ...values.rewardOperatorConfguraion.tl,
                              isUse: true,
                            },
                            bl: {
                              ...values.rewardOperatorConfguraion.bl,
                              isUse: true,
                            },
                            gp: {
                              ...values.rewardOperatorConfguraion.gp,
                              isUse: true,
                            },
                          });
                        } else {
                          setFieldValue("rewardOperatorConfguraion", {
                            all: false,
                            robi: {
                              ...values.rewardOperatorConfguraion.robi,
                              isUse: false,
                            },
                            tl: {
                              ...values.rewardOperatorConfguraion.tl,
                              isUse: false,
                            },
                            bl: {
                              ...values.rewardOperatorConfguraion.bl,
                              isUse: false,
                            },
                            gp: {
                              ...values.rewardOperatorConfguraion.gp,
                              isUse: false,
                            },
                          });
                        }
                      }}
                      legend={"All Operators"}
                      name={"rewardOperatorConfguraion.all"}
                      sx={{ pr: 0 }}
                    />
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.rewardOperatorConfguraion.tl.isUse &&
                            values.rewardOperatorConfguraion.bl.isUse &&
                            values.rewardOperatorConfguraion.gp.isUse
                          ) {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: true,
                              robi: {
                                ...values.rewardOperatorConfguraion.robi,
                                isUse: e?.target.checked,
                              },
                            });
                          } else {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: false,
                              robi: {
                                ...values.rewardOperatorConfguraion.robi,
                                isUse: e?.target.checked,
                              },
                            });
                          }
                        }}
                        legend={"Robi"}
                        name={"rewardOperatorConfguraion.robi.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.robi.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.robi.userName"
                          label="Username"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.robi.isUse}
                          type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                  {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          name="rewardOperatorConfguraion.robi.password"
                          label="Password"
                          placeholder="Password"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.rewardOperatorConfguraion.robi.isUse &&
                            values.rewardOperatorConfguraion.bl.isUse &&
                            values.rewardOperatorConfguraion.gp.isUse
                          ) {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: true,
                              tl: {
                                ...values.rewardOperatorConfguraion.tl,
                                isUse: e?.target.checked,
                              },
                            });
                          } else {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: false,
                              tl: {
                                ...values.rewardOperatorConfguraion.tl,
                                isUse: e?.target.checked,
                              },
                            });
                          }
                        }}
                        legend={"Teletalk"}
                        name={"rewardOperatorConfguraion.tl.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.tl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.tl.userName"
                          label="Username"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.tl.isUse}
                          type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                  {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          name="rewardOperatorConfguraion.tl.password"
                          label="Password"
                          placeholder="Password"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.rewardOperatorConfguraion.tl.isUse &&
                            values.rewardOperatorConfguraion.robi.isUse &&
                            values.rewardOperatorConfguraion.gp.isUse
                          ) {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: true,
                              bl: {
                                ...values.rewardOperatorConfguraion.bl,
                                isUse: e?.target.checked,
                              },
                            });
                          } else {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: false,
                              bl: {
                                ...values.rewardOperatorConfguraion.bl,
                                isUse: e?.target.checked,
                              },
                            });
                          }
                        }}
                        legend={"Banglalink"}
                        name={"rewardOperatorConfguraion.bl.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={3.5} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.userName"
                          label="Username"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item lg={3.5} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                  {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          name="rewardOperatorConfguraion.bl.password"
                          label="Password"
                          placeholder="Password"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.clientId"
                          label="Client Id"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.grantType"
                          label="Grant Type"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.scope"
                          label="Scope"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.clientSecret"
                          label="Client Secret"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.senderMsisdn"
                          label="Sender Msisdn"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.rewardOperatorConfguraion.tl.isUse &&
                            values.rewardOperatorConfguraion.bl.isUse &&
                            values.rewardOperatorConfguraion.robi.isUse
                          ) {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: true,
                              gp: {
                                ...values.rewardOperatorConfguraion.gp,
                                isUse: e?.target.checked,
                              },
                            });
                          } else {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: false,
                              gp: {
                                ...values.rewardOperatorConfguraion.gp,
                                isUse: e?.target.checked,
                              },
                            });
                          }
                        }}
                        legend={"Grameenphone"}
                        name={"rewardOperatorConfguraion.gp.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.gp.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.gp.clientId"
                          label="Client Id"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.gp.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.gp.grantType"
                          label="Grant Type"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.gp.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.gp.clientSecret"
                          label="Client Secret"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    {!values.rewardOperatorConfguraion.bl.isUse &&
                      !values.rewardOperatorConfguraion.gp.isUse &&
                      !values.rewardOperatorConfguraion.robi.isUse &&
                      !values.rewardOperatorConfguraion.tl.isUse && (
                        <Typography variant="caption" color={"error"}>
                          At least one data reward operator required
                        </Typography>
                      )}
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        )}
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Button color="primary" type="button" startIcon={<ArrowBackIcon />} onClick={handleBack} variant="contained">
              Back
            </Button>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              size="medium"
              disabled={!dirty || isSubmitting || !isValid}
              startIcon={
                isLoading && (
                  <CircularProgress
                    size={"20px"}
                    sx={{
                      mr: 1,
                      color: "gray",
                    }}
                  />
                )
              }
            >
              Create User
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </MainCard>
  );
}

export default OperatorConfiguration;
